export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7857.9048869f.jpg";